/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChatTurn } from './ChatTurn';
import {
    ChatTurnFromJSON,
    ChatTurnFromJSONTyped,
    ChatTurnToJSON,
    ChatTurnToJSONTyped,
} from './ChatTurn';
import type { ChatbotSettingsOverrides } from './ChatbotSettingsOverrides';
import {
    ChatbotSettingsOverridesFromJSON,
    ChatbotSettingsOverridesFromJSONTyped,
    ChatbotSettingsOverridesToJSON,
    ChatbotSettingsOverridesToJSONTyped,
} from './ChatbotSettingsOverrides';

/**
 * 
 * @export
 * @interface SimpleChatRequestDto
 */
export interface SimpleChatRequestDto {
    /**
     * 
     * @type {Array<ChatTurn>}
     * @memberof SimpleChatRequestDto
     */
    history: Array<ChatTurn>;
    /**
     * 
     * @type {ChatbotSettingsOverrides}
     * @memberof SimpleChatRequestDto
     */
    chatbotSettingsOverrides: ChatbotSettingsOverrides;
    /**
     * 
     * @type {string}
     * @memberof SimpleChatRequestDto
     */
    responseLanguage?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleChatRequestDto
     */
    threadId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleChatRequestDto
     */
    userName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SimpleChatRequestDto
     */
    enableWebSearch: boolean;
    /**
     * 
     * @type {string}
     * @memberof SimpleChatRequestDto
     */
    readonly lastUserQuestion?: string | null;
}

/**
 * Check if a given object implements the SimpleChatRequestDto interface.
 */
export function instanceOfSimpleChatRequestDto(value: object): value is SimpleChatRequestDto {
    if (!('history' in value) || value['history'] === undefined) return false;
    if (!('chatbotSettingsOverrides' in value) || value['chatbotSettingsOverrides'] === undefined) return false;
    if (!('enableWebSearch' in value) || value['enableWebSearch'] === undefined) return false;
    return true;
}

export function SimpleChatRequestDtoFromJSON(json: any): SimpleChatRequestDto {
    return SimpleChatRequestDtoFromJSONTyped(json, false);
}

export function SimpleChatRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimpleChatRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'history': ((json['history'] as Array<any>).map(ChatTurnFromJSON)),
        'chatbotSettingsOverrides': ChatbotSettingsOverridesFromJSON(json['chatbotSettingsOverrides']),
        'responseLanguage': json['responseLanguage'] == null ? undefined : json['responseLanguage'],
        'threadId': json['threadId'] == null ? undefined : json['threadId'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'enableWebSearch': json['enableWebSearch'],
        'lastUserQuestion': json['lastUserQuestion'] == null ? undefined : json['lastUserQuestion'],
    };
}

export function SimpleChatRequestDtoToJSON(json: any): SimpleChatRequestDto {
    return SimpleChatRequestDtoToJSONTyped(json, false);
}

export function SimpleChatRequestDtoToJSONTyped(value?: Omit<SimpleChatRequestDto, 'lastUserQuestion'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'history': ((value['history'] as Array<any>).map(ChatTurnToJSON)),
        'chatbotSettingsOverrides': ChatbotSettingsOverridesToJSON(value['chatbotSettingsOverrides']),
        'responseLanguage': value['responseLanguage'],
        'threadId': value['threadId'],
        'userName': value['userName'],
        'enableWebSearch': value['enableWebSearch'],
    };
}

